// extracted by mini-css-extract-plugin
export default {"photo":"styles_photo__Km9kM","visualization":"styles_visualization__Fr2RI"};